import React from "react";
import AuthContainer from "../components/AuthContainer/AuthContainer";
import CheckEmailBox from "../components/CheckEmailBox/CheckEmailBox";

const CheckEmail = () => {
  return (
    <AuthContainer>
      <CheckEmailBox />
    </AuthContainer>
  );
};

export default CheckEmail;
